import { useEffect, useState } from "react";

import { isEmpty, isEqual } from "lodash";

const useDebounce = <T>(value: T, delay: number, initEmpty: boolean = false) => {
  const [debounceValue, setDebounceValue] = useState<T>();

  useEffect(() => {
    if (isEmpty(value) || isEqual(debounceValue, value)) {
      return;
    }

    const handler = setTimeout(() => {
      setDebounceValue(value);
    }, delay);

    if (!initEmpty && isEmpty(debounceValue)) {
      setDebounceValue(value);
    }

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debounceValue as T;
};

export default useDebounce;
